import type { IconType } from '@shared/types/icon.type';

export const createAction = (
  label: string,
  startIcon: IconType,
  callback: () => void,
  isDisabled: boolean = false,
) => {
  return {
    label,
    callback,
    isContainStartIcon: true,
    startIcon,
    isDisabled,
  };
};
